<template>
  <svg
    fill="none"
    height="394"
    viewBox="0 0 362 394"
    width="362"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.06"
      rx="8"
      transform="matrix(1 0 0 -1 114 405)"
      width="80"
    />
    <rect
      fill="url(#paint0_linear_107_9106)"
      height="80"
      opacity="0.03"
      rx="8"
      transform="matrix(1 0 0 -1 198 153)"
      width="80"
    />
    <rect
      fill="url(#paint1_linear_107_9106)"
      height="80"
      opacity="0.06"
      rx="8"
      transform="matrix(1 0 0 -1 282 69)"
      width="80"
    />
    <rect
      fill="url(#paint2_linear_107_9106)"
      height="80"
      opacity="0.04"
      rx="8"
      transform="matrix(1 0 0 -1 198 405)"
      width="80"
    />
    <rect
      fill="#F3F5F7"
      height="80"
      opacity="0.06"
      rx="8"
      transform="matrix(1 0 0 -1 198 69)"
      width="80"
    />
    <rect
      fill="url(#paint3_linear_107_9106)"
      height="80"
      opacity="0.04"
      rx="8"
      transform="matrix(1 0 0 -1 198 321)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.12"
      rx="8"
      transform="matrix(1 0 0 -1 114 321)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.04"
      rx="8"
      transform="matrix(1 0 0 -1 114 237)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.02"
      rx="8"
      transform="matrix(1 0 0 -1 114 153)"
      width="80"
    />
    <rect
      fill="#F1F5F9"
      height="80"
      opacity="0.12"
      rx="40"
      transform="matrix(1 0 0 -1 114 69)"
      width="80"
    />
    <path
      d="M146.629 33.2552V29.9375L149.328 31.4941V34.8144L146.629 33.2552Z"
      fill="white"
    />
    <path
      d="M146.629 24.7446L149.429 23.127L154 25.7673L158.571 23.127L161.371 24.7446V27.6851L156.723 30.3705V35.9407L154 37.5132L151.277 35.9407V30.3705L146.629 27.6851V24.7446Z"
      fill="white"
    />
    <path
      d="M141.954 24.9863V22.0459L144.754 20.4282L147.479 22.0007L144.679 23.6184V26.5588L141.954 24.9863Z"
      fill="white"
    />
    <path
      d="M163.321 26.5588V23.6184L160.521 22.0007L163.246 20.4282L166.046 22.0459V24.9863L163.321 26.5588Z"
      fill="white"
    />
    <path
      d="M161.371 33.2552L158.672 34.8144V31.4941L161.371 29.9375V33.2552Z"
      fill="white"
    />
    <path
      d="M151.277 38.1934L154 39.7659L156.723 38.1934V41.3384L154 42.9109L151.277 41.3384V38.1934Z"
      fill="white"
    />
    <path
      d="M151.378 22.0009L154 20.4868L156.622 22.0009L154 23.5149L151.378 22.0009Z"
      fill="white"
    />
    <path
      d="M144.679 28.8113V34.3814L149.328 37.0669V40.2119L141.954 35.9539V27.2388L144.679 28.8113Z"
      fill="white"
    />
    <path
      d="M158.672 37.0669L163.321 34.3814V28.8113L166.046 27.2388V35.9539L158.672 40.2119V37.0669Z"
      fill="white"
    />
    <path
      d="M158.572 20.8747L154 18.237L149.429 20.8747L146.703 19.3022L154 15.0894L161.297 19.3022L158.572 20.8747Z"
      fill="white"
    />
    <rect
      fill="#EBEDF5"
      height="80"
      opacity="0.12"
      rx="40"
      transform="matrix(1 0 0 -1 30 405)"
      width="80"
    />
    <path
      d="M62.0899 356.391L81.8604 352.999L71.501 379.187L56.7189 361.523L62.0899 356.391ZM62.4458 358.035L59.2583 361.071L67.0783 362.147L62.4458 358.035ZM69.3521 362.24L78.1469 355.092L64.021 357.515L69.3521 362.24ZM70.0958 363.483L71.6364 374.977L79.05 356.205L70.0958 363.483ZM68.6933 363.815L59.4496 362.543L70.2472 375.444L68.6933 363.815Z"
      fill="white"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.06"
      rx="8"
      transform="matrix(1 0 0 -1 30 321)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.12"
      rx="8"
      transform="matrix(1 0 0 -1 30 153)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.02"
      rx="8"
      transform="matrix(1 0 0 -1 30 69)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.12"
      rx="8"
      transform="matrix(1 0 0 -1 -54 405)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.12"
      rx="8"
      transform="matrix(1 0 0 -1 -54 321)"
      width="80"
    />
    <rect
      fill="#F3F5F7"
      height="80"
      opacity="0.06"
      rx="8"
      transform="matrix(1 0 0 -1 -54 237)"
      width="80"
    />
    <rect
      fill="url(#paint4_linear_107_9106)"
      height="80"
      opacity="0.02"
      rx="8"
      transform="matrix(1 0 0 -1 198 237)"
      width="80"
    />
    <rect
      fill="#F1F5F9"
      height="80"
      opacity="0.12"
      rx="40"
      transform="matrix(1 0 0 -1 -54 153)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.06"
      rx="8"
      transform="matrix(1 0 0 -1 -54 69)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.02"
      rx="8"
      transform="matrix(1 0 0 -1 30 237)"
      width="80"
    />
    <defs>
      <linearGradient
        id="paint0_linear_107_9106"
        gradientUnits="userSpaceOnUse"
        x1="-6.82101e-07"
        x2="80"
        y1="41.5"
        y2="42"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_107_9106"
        gradientUnits="userSpaceOnUse"
        x1="-6.82101e-07"
        x2="80"
        y1="41.5"
        y2="42"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_107_9106"
        gradientUnits="userSpaceOnUse"
        x1="-6.82101e-07"
        x2="80"
        y1="41.5"
        y2="42"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_107_9106"
        gradientUnits="userSpaceOnUse"
        x1="-6.82101e-07"
        x2="80"
        y1="41.5"
        y2="42"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_107_9106"
        gradientUnits="userSpaceOnUse"
        x1="-6.82101e-07"
        x2="80"
        y1="41.5"
        y2="42"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'NlpCheckAddressBackground1',
}
</script>